import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { styled } from '@stitches/react';
import AboutCompany from './AboutCompany';
import AboutTeam from './AboutTeam';

// 主要背景样式
const MainBackground = styled('div', {
  position: 'fixed',
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  background: 'var(--background-color)', // 使用项目的UI背景颜色变量
  zIndex: -10,
  pointerEvents: 'none'
});

// 关于我们页面容器
const AboutContainer = styled('div', {
  width: '100%',
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '0 1rem',
  position: 'relative',
  minHeight: 'calc(100vh - 300px)', // 修改高度，为页脚留出空间
  paddingBottom: '100px', // 添加底部内边距
  overflow: 'hidden'
});

// 内容区域
const ContentContainer = styled('div', {
  position: 'relative',
  zIndex: 1,
  padding: '2rem 0',
});

// 装饰性背景元素
const BackgroundElement = styled('div', {
  position: 'absolute',
  zIndex: -1,
  pointerEvents: 'none',
  
  variants: {
    type: {
      topRight: {
        top: '5%',
        right: 0,
        width: '300px',
        height: '300px',
        background: 'radial-gradient(circle, rgba(106, 126, 252, 0.05) 0%, rgba(106, 126, 252, 0) 70%)',
      },
      bottomLeft: {
        bottom: '5%',
        left: 0,
        width: '400px',
        height: '400px',
        background: 'radial-gradient(circle, rgba(106, 126, 252, 0.05) 0%, rgba(106, 126, 252, 0) 70%)',
      },
      center: {
        top: '40%',
        right: '10%',
        width: '200px',
        height: '200px',
        background: 'radial-gradient(circle, rgba(106, 126, 252, 0.03) 0%, rgba(106, 126, 252, 0) 70%)',
      }
    }
  }
});

/**
 * 关于我们页面组件
 * 提供公司介绍、团队介绍和联系方式等相关功能的路由
 */
const AboutPage: React.FC = () => {
  // const { t } = useTranslation(); // 暂时未使用
  
  return (
    <>
      <MainBackground />
      
      <AboutContainer>
        {/* 装饰性背景元素 */}
        <BackgroundElement type="topRight" />
        <BackgroundElement type="bottomLeft" />
        <BackgroundElement type="center" />
        
        {/* 内容区域 */}
        <ContentContainer>
          <Routes>
            {/* 公司介绍页面 */}
            <Route index element={<AboutCompany />} />
            
            {/* 团队介绍页面 */}
            <Route path="team" element={<AboutTeam />} />
            
            {/* 重定向到公司介绍 */}
            <Route path="*" element={<Navigate to="/about" replace />} />
          </Routes>
        </ContentContainer>
      </AboutContainer>
    </>
  );
};

export default AboutPage; 